/*
* AppConfig.scss
*
* Description: Schedulers Config
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
* Copyright 2018,2019,2020,2021,2022,2023 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';

import { Scheduler, StringHelper, DateHelper, LocaleManager } from '@bryntum/scheduler';
import { store } from '../../../../stores/store';
import { eventBus } from '../../../../main';
import {
    CONF_CALENDAR_LOCKED_DUTIES,
} from '../../../../config.js'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$                       /$$$$$$  /$$                   /$$
// #   /$$__  $$                     /$$__  $$|__/                 /$$$$
// #  | $$  \__/  /$$$$$$  /$$$$$$$ | $$  \__/ /$$  /$$$$$$       |_  $$
// #  | $$       /$$__  $$| $$__  $$| $$$$    | $$ /$$__  $$        | $$
// #  | $$      | $$  \ $$| $$  \ $$| $$_/    | $$| $$  \ $$        | $$
// #  | $$    $$| $$  | $$| $$  | $$| $$      | $$| $$  | $$        | $$
// #  |  $$$$$$/|  $$$$$$/| $$  | $$| $$      | $$|  $$$$$$$       /$$$$$$
// #   \______/  \______/ |__/  |__/|__/      |__/ \____  $$      |______/
// #                                               /$$  \ $$
// #                                              |  $$$$$$/
// #                                               \______/
// #    /$$$$$$            /$$                       /$$           /$$
// #   /$$__  $$          | $$                      | $$          | $$
// #  | $$  \__/  /$$$$$$$| $$$$$$$   /$$$$$$   /$$$$$$$ /$$   /$$| $$  /$$$$$$   /$$$$$$
// #  |  $$$$$$  /$$_____/| $$__  $$ /$$__  $$ /$$__  $$| $$  | $$| $$ /$$__  $$ /$$__  $$
// #   \____  $$| $$      | $$  \ $$| $$$$$$$$| $$  | $$| $$  | $$| $$| $$$$$$$$| $$  \__/
// #   /$$  \ $$| $$      | $$  | $$| $$_____/| $$  | $$| $$  | $$| $$| $$_____/| $$
// #  |  $$$$$$/|  $$$$$$$| $$  | $$|  $$$$$$$|  $$$$$$$|  $$$$$$/| $$|  $$$$$$$| $$
// #   \______/  \_______/|__/  |__/ \_______/ \_______/ \______/ |__/ \_______/|__/
// #
//-----------------------------------------------------------------------------/
const scheduler1Config = {                                                      // 'Calendar'
    startDate: new Date(2021, 9, 21, 0),
    endDate: new Date(2021, 10, 21, 0),

    // >>> layout -----------------------------------------
    rowHeight: 42,
    barMargin: 4,
    resourceMargin: 6,
    flex: '1 70%', // 1 1 50%
    eventLayout : 'pack',

    // >>> features ---------------------------------------
    stripeFeature: true,
    nonWorkingTimeFeature: true, // 'weekends'
    // useInitialAnimation: 'slide-from-left',
    createEventOnDblClick: false,
    filterBarFeature: true,
    columnLinesFeature: true,
    eventResizeFeature: false,
    cellTooltipFeature: false,
    scheduleTooltipFeature: false,
    resourceTimeRangesFeature: true, // BD
    zoomOnMouseWheel: false,

    // >>> copy&paste -------------------------------------
    eventCopyPasteFeature: false,
    rowCopyPasteFeature: false,

    // >>> drag&drop --------------------------------------
    multiEventSelect : true,
    eventDragSelectFeature: true,
    eventDragCreateFeature: false,
    eventDragFeature: false,
    eventDragFeature: {
        constrainDragToTimeline: false, // Allow drag outside of this Scheduler
        constrainDragToResource: false, // Resource fixed, only allowed to change start date
        constrainDragToTimeSlot: true, // Start date is fixed, only move between resources
        tooltipTemplate: ({ eventRecord, startDate }) => {
            return 'Michael- DND Calendar ' + DateHelper.format(startDate, 'HH:mm');
        },
        validatorFn({ eventRecords, newResource }) {
            const task  = eventRecords[0],
                  valid = newResource.role === task.resource.role;


            return {
                valid   : newResource.role === task.resource.role,
                message : valid ? '' : 'Resource role does not match required role for this task'
            };
        }
    },

    // >>> timeRangesFeature ------------------------------
    timeRangesFeature: {
        showCurrentTimeLine : true,
        showHeaderElements  : true,
        enableResizing      : false,
    },

    // >>> timeAxisHeaderMenuFeature ----------------------
    timeAxisHeaderMenuFeature: {
        items : {
            zoomLevel : false,
            eventsFilter: false,
            dateRange: false,
            currentTimeLine: false,
        }
    },

    // >>> summaryFeature ---------------------------------
    summaryFeature: {
        renderer : ({ events }) => events.length || ''
    },

    // >>> eventMenuFeature -------------------------------
    eventMenuFeature: {
        items: {
            deleteEvent : false,
            cutEvent: false,
            copyEvent: false,
            editEvent : true,
        },
        processItems({ eventRecord, items }) {

            // >>> --------------------------
            if (eventRecord.name === 'FLIGHT') {
                items.deleteEvent = false;
                items.editEvent.text = 'UPDATE FLIGHT COMMENT -------------------- (SINGLE)';

                items.delete_MEMBERONFLIGHT = {
                    html : '<span style="color: red;">DELETE MEMBER FROM FLIGHT(S) </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;<span style="float:right; color: #424242;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: red; padding-top: 20px; padding-bottom: 20px;',
                    onItem (ev) { // { date, resourceRecord }
                        const { eventRecord, resourceRecord } = ev;


                        eventBus.$emit('onclickdeletememberonflight', { eventRecord, resourceRecord });
                        this.hide();
                    }
                };
            }
            if (eventRecord.name === 'CHECKOUT') {
                items.editEvent = items.deleteEvent = false;
            }
            if (eventRecord.name === 'CHECKIN') {
                items.editEvent = items.deleteEvent = false;
            }
            // <<< --------------------------


            // >>> --------------------------
            if (eventRecord.name === 'HOTEL') {                             // MULTI EDIT, DELETE, 'CHNAGE STAUS MULTIPLE', 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE HOTEL(S) ------- (multiple)';
                items.exchange = {
                    html : 'CHANGE HOTEL(S)<span style="float:right;"> (multiple)</span>',
                    icon : 'b-fa b-fa-exchange-alt',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        // eventBus.$emit('onclickhotelchangestatus', eventRecord); // single update
                        eventBus.$emit('onclickchangestatusmultiplehotels', eventRecord); // multiple update
                    }
                };
                items.delete = {
                    html : 'DELETE HOTEL<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'PROCEEDING') {                        // MULTI EDIT, DELETE, 'ACTIVATE', 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE PROCEEDING(S) ----- (multiple)';
                items.exchange = {
                    html : 'CHANGE PROCEEDING <span style="float:right;">(status)</span>',
                    icon : 'b-fa b-fa-exchange-alt',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickproceedingchangestatus', eventRecord);
                    }
                };
                items.delete = {
                    html : 'DELETE PROCEEDING <span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'TRAINING') {                          // MULTI EDIT, DELETE, 'ACTIVATE', 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE TRAINING(S) ----- (multiple)';
                items.delete = {
                    html : 'DELETE TRAINING <span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'MEETING') {                           // MULTI EDIT, DELETE, 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE MEETING(S) ----------- (multiple)';
                items.delete = {
                    html : 'DELETE MEETING<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'STANDBY') {                           // MULTI EDIT, DELETE, 'ACTIVATE', 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE STANDBY(s) ----------- (multiple)';
                items.activation = {
                    html : 'ACTIVATE STANDBY<span style="float:right;">(status)</span> ',
                    icon : 'b-fa b-fa-exchange-alt',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickstandbychangeactivated', eventRecord);
                        this.hide();
                    }
                };
                items.delete = {
                    html : 'DELETE STANDBY<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'SICKNESS') {                          // MULTI EDIT, DELETE, 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE SICKNESS(s) ----------- (multiple)';
                items.exchange = {
                    html : 'CHANGE SICKNESS(ES)<span style="float:right;"> (multiple)</span>',
                    icon : 'b-fa b-fa-exchange-alt',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickchangestatusmultiplesicknesses', eventRecord); // multiple update
                    }
                };
                items.delete = {
                    html : 'DELETE SICKNESS<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'OFFICE') {                            // MULTI EDIT, DELETE, 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE OFFICE(s) ----------- (multiple)';
                items.delete = {
                    html : 'DELETE OFFICE<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'DAYOFF') {                            // MULTI EDIT, DELETE, 'ACTIVATE', 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE DAYOFF(s) ---------- (multiple)';
                items.exchange = {
                    html : 'CHANGE DAYOFF<span style="float:right;">(status)</span>',
                    icon : 'b-fa b-fa-exchange-alt',
                    cls  : 'b-separator ',
                    style: 'color: #424242;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdayoffchangeactivated', eventRecord);
                    }
                };
                items.delete = {
                    html : 'DELETE DAYOFF<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    style: 'color: #424242;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'UNABLEFLIGHT') {                      // MULTI EDIT, DELETE, 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE UNABLEFLIGHT(s) ----- (multiple)';
                items.delete = {
                    html : 'DELETE UNABLEFLIGHT<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }
            // <<< --------------------------


            // >>> --------------------------
            if (eventRecord.name === 'FREEDAY') {                           // EDIT, DELETE, 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE FREEDAY ----------- (single)';
                items.exchange = {
                    html : 'CHANGE FREEDAY<span style="float:right;">(status)</span>',
                    icon : 'b-fa b-fa-exchange-alt',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickfreedaychangeactivated', eventRecord);
                    }
                };
                items.delete = {
                    html : 'DELETE FREEDAY<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'AVAILABLE') {                         // EDIT, DELETE, 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE AVAILABLE ----- (single)';
                items.delete = {
                    html : 'DELETE AVAILABLE<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'RESERVE') {                           // EDIT, DELETE, 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE RESERVE --------- (single)';
                items.delete = {
                    html : 'DELETE RESERVE<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }

            if (eventRecord.name === 'VACATION') {                          // EDIT, DELETE, 'DELETE ALL'
                items.deleteEvent = false;

                items.editEvent.text = 'UPDATE VACATION --------- (single)';
                items.delete = {
                    html : 'DELETE VACATION<span style="float:right;">(single)</strong>',
                    icon : 'b-fa b-fa-trash',
                    cls  : 'b-separator ',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeletesingleduty', eventRecord);
                        this.hide();
                    }
                };
                items.deleteall = {
                    html : 'DELETE ALL MARKED ITEMS<span style="float:right;">(!)</span>',
                    icon : 'b-fa b-fa-exclamation-triangle',
                    cls  : 'b-separator ',
                    style: 'color: #e53f2c; padding-top: 20px; padding-bottom: 20px; border-left: 1px solid #e53f2c;  border-right: 1px solid #e53f2c;',
                    onItem({ eventRecord }) {
                        eventBus.$emit('onclickdeleteallmarkedduties', eventRecord);
                        this.hide();
                    }
                };
            }
            // >>> --------------------------


            // Prevent menu for "locked" event
            return !eventRecord.locked;

        },
    },

    // >>> scheduleMenuFeature ----------------------------
    scheduleMenuFeature: {
        processItems({date, resourceRecord, items}) {

            items.addEvent =  false;

            if (resourceRecord !== false) {

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('AVAILABLE')) {
                    items.add_AVAILABLE = {
                        html : '<span style="color: #424242;">AVAILABLE</span><span style="float:right; color: #424242;">(create)</span>',
                        icon : 'b-fa b-fa-check-circle',
                        cls  : 'b-separator ',
                        style: 'color: pink;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddavailable', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('DAYOFF')) {
                    items.add_DAYOFF = {
                        html : '<span style="color: #424242;">DAYOFF <span><span style="float:right; color: #424242;">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-coffee',
                        cls  : 'b-separator ',
                        style: 'color: yellow;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddmultipledayoff', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('FREEDAY')) {
                    items.add_FREEDAY = {
                        html : '<span style="color: #424242;">FREEDAY </span><span style="float:right; color: #424242;">(create)</span>',
                        icon : 'b-fa b-fa-coffee',
                        cls  : 'b-separator ',
                        style: 'color: yellow;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddfreeday', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('HOTEL')) {
                    items.add_HOTEL = {
                        html : '<span style="color: #424242;">HOTEL <span style="float:right; color: #424242;">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-hotel',
                        cls  : 'b-separator ',
                        style: 'color: violet;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddmultiplehotels', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('MEETING')) {
                    items.add_MEETING = {
                        html : '<span style="color: #424242;">MEETING </span><span style="float:right; color: #424242;"">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-user-friends',
                        cls  : 'b-separator ',
                        style: 'color: indigo;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddmultiplemeetings', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('OFFICE')) {
                    items.add_OFFICE = {
                        html : '<span style="color: #424242;">OFFICE </span><span style="float:right; color: #424242;">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-envelope',
                        cls  : 'b-separator ',
                        style: 'color: blue;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddmultipleoffice', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('PRO')) {
                    items.add_PRO = {
                        html : '<span style="color: #424242;">PRO </span><span style="float:right; color: #424242;">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-car',
                        cls  : 'b-separator ',
                        style: 'color: green;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddmultipleproceedings', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('RESERVE')) {
                    items.add_RESERVE = {
                        html : '<span style="color: #424242;">RESERVE </span><span style="float:right; color: #424242;">(create)</span>',
                        icon : 'b-fa b-fa-exchange-alt',
                        cls  : 'b-separator ',
                        style: 'color: orange;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddreserve', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('SICKNESS')) {
                    items.add_SICKNESS = {
                        html : '<span style="color: #424242;">SICKNESS </span><span style="float:right; color: #424242;">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-briefcase-medical',
                        cls  : 'b-separator ',
                        style: 'color: gray;',
                        onItem({ date, resourceRecord }) {
                            // eventBus.$emit('onclickaddsickness', { date, resourceRecord });
                            eventBus.$emit('onclickaddmultiplesickness', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('STANDBY')) {
                    items.add_STANDBY = {
                        html : '<span style="color: #424242;">STANDBY </span><span style="float:right; color: #424242;">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-bullhorn',
                        cls  : 'b-separator ',
                        style: 'color: red;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddmultiplestandby', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('TRAINING')) {
                    items.add_TRAINING = {
                        html : '<span style="color: #424242;">TRAINING </span><span style="float:right; color: #424242;">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-graduation-cap',
                        cls  : 'b-separator ',
                        style: 'color: orange;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddmultipletrainings', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('UNABLEFLIGHT')) {
                    items.add_UNABLEFLIGHT = {
                        html : '<span style="color: #424242;">UNABLEFLIGHT </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp;<span style="float:right; color: #424242;">(MULTIPLE)</span>',
                        icon : 'b-fa b-fa-ban',
                        cls  : 'b-separator ',
                        style: 'color: red;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddmultipleunableflights', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('VACATION')) {
                    items.add_VACATION = {
                        html : '<span style="color: #424242;">VACATION </span><span style="float:right; color: #424242;">(create)</span>',
                        icon : 'b-fa b-fa-umbrella-beach',
                        cls  : 'b-separator ',
                        style: 'color: gray;',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickaddvacation', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }

                if (!CONF_CALENDAR_LOCKED_DUTIES.includes('SWITCHDUTY')) {
                    items.add_SWITCHDUTY = {
                        html : 'SWITCH DUTY <span style="float:right;">(switch)</span>',
                        icon : 'b-fa b-fa-random',
                        cls  : 'b-separator ',
                        style: 'color: #000; padding-top: 30px; font-weight: 800; ',
                        onItem({ date, resourceRecord }) {
                            eventBus.$emit('onclickswitchduty', { date, resourceRecord });
                            this.hide();
                        }
                    };
                }
            }
        }
    },

    // >>> eventEditFeature -------------------------------
    eventEditFeature: {
        triggerEvent: {
            eventdblclick: null
        }
    },

    // >>> cellMenuFeature --------------------------------
    cellMenuFeature : {
        items: {
            removeRow : false,
            cut: false,
            copy: false,
        },
        processItems({date, resourceRecord, items}) {
        }
    },

    // >>> eventTooltipFeature ----------------------------
    eventTooltipFeature : {
        hideOnDelegateChange: true,
        tools : [
            // >>> ------------------------------ Change Status
            {
                cls     : 'b-fa b-fa-exchange-alt',
                style   : 'margin-left: 100px; color: #fff;',
                tooltip : '<span style="font-family: Roboto;">Change status/activated</span>',
                handler : function() {
                    if (this.eventRecord.data.name === 'HOTEL') {
                        eventBus.$emit('onclickhotelchangestatus', this.eventRecord);
                    }
                    if (this.eventRecord.data.name === 'PROCEEDING') {
                        eventBus.$emit('onclickproceedingchangestatus', this.eventRecord);
                    }
                    if (this.eventRecord.data.name === 'DAYOFF') {
                        eventBus.$emit('onclickdayoffchangeactivated', this.eventRecord);
                    }
                    if (this.eventRecord.data.name === 'FREEDAY') {
                        eventBus.$emit('onclickfreedaychangeactivated', this.eventRecord);
                    }
                }
            },
            // >>> ------------------------------ Delete single Duty
            {
                cls     : 'b-fa b-fa-trash',
                style   : 'margin-left: 15px; color: #fff;',
                tooltip : '<span style="font-family: Roboto;">Delete single Duty</span>',
                handler : function() {
                    if (this.eventRecord.data.name === 'HOTEL') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'PROCEEDING') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'TRAINING') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'STANDBY') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'DAYOFF') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'FREEDAY') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'MEETING') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'OFFICE') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'UNABLEFLIGHT') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'AVAILABLE') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'SICKNESS') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'RESERVE') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    } else if (this.eventRecord.data.name === 'VACATION') {
                        eventBus.$emit('onclickdeletesingleduty', this.eventRecord);
                        this.hide();
                    }
                }
            },
            // >>> ------------------------------ Phone Number
            {
                cls     : 'b-fa b-fa-phone',
                style   : 'margin-left: 15px; color: #fff;',
                tooltip : '<span style="font-family: Roboto;">Copy PhoneNo</span>',
                handler : function() {
                    eventBus.$emit('onclickphonenumber', this.eventRecord.resource.comPhone1.trim());
                    this.hide();
                }
            },
        ],
        template : data => `
            <dl>
                ${data.eventRecord.get('name') == 'FLIGHT' ?
                `
                    ${data.eventRecord.get('note') ? `<dd>${data.eventRecord.note}</dd>` : ''}
                    <br /><dt><strong>Crew:</strong></dt>
                    <dd>
                        <strong>${data.eventRecord.crew}</strong>
                    </dd>
                ` : '' }


                ${data.eventRecord.get('name') != 'FLIGHT' ?
                `
                    ${data.eventRecord.get('note') ? `<dd>${data.eventRecord.note}</dd>` : ''}
                ` : '' }


                <br /><dt><strong>Assigned to:</strong></dt>
                <dd>
                    ${data.eventRecord.resource.lastName.trim()}, ${data.eventRecord.resource.firstName.trim()}
                </dd>
                <dd>
                    ${data.eventRecord.resource.contract3Code} - ${data.eventRecord.resource.contractFunction.trim()} ${data.eventRecord.resource.contractAddFunction.trim()}
                </dd>
                <dd style="margin-top: 7px;">
                    <a href="#" onClick="return false;">${data.eventRecord.resource.comPhone1.trim()}</a>
                </dd>
            </dl>
        `
    },

    // >>> eventRenderer ----------------------------------
    eventRenderer({ eventRecord, resourceRecord, tplData }) {
        return eventRecord.nameEvent;
    },

    // >>> presets ----------------------------------------
    presets: [
        { // >>> 'overviewPreset'
            id: 'overviewPreset',
            name: 'Sundair Custom Overview Preset',
            tickWidth: 45,
            timeResolution: {
                unit: 'minute',
                increment: 5
            },
            headers: [
                {
                    unit: 'day',
                    align: 'center',
                    dateFormat: 'ddd, Y-MM-DD'
                },
                {
                    unit: 'hour',
                    align: 'center',
                    dateFormat: 'HH:mm',
                    increment: 12,
                },
            ],
        },
        { // >>> 'normalPreset'
            id: 'normalPreset',
            name: 'Sundair Custom Day Preset',
            tickWidth: 75,
            timeResolution: {
                unit: 'minute',
                increment: 5
            },
            headers: [
                {
                    unit: 'day',
                    align: 'center',
                    dateFormat: 'ddd, Y-MM-DD'
                },
                {
                    unit: 'hour',
                    align: 'center',
                    dateFormat: 'HH',
                    increment: 6

                }
            ],
        },
        { // >>> 'hourPreset'
            id: 'hourPreset',
            name: 'Sundair Custom Hour Preset',
            tickWidth: 75,
            timeResolution: {
                unit: 'minute',
                increment: 5
            },
            headers: [
                {
                    unit: 'day',
                    align: 'center',
                    dateFormat: 'ddd, Y-MM-DD'
                },
                {
                    unit: 'hour',
                    align: 'center',
                    dateFormat: 'HH',
                    increment: 1
                },
                // {
                //     unit: 'minute',
                //     increment: 15,
                //     dateFormat: 'mm',
                // },
            ],
        },
    ],

    // >>> viewPreset -------------------------------------
    viewPreset: {
        base: 'hourAndDay',
        tickWidth: 75,
        headers: [
            {
                unit: 'day',
                align: 'center',
                dateFormat: 'ddd, Y-MM-DD'
            },
            {
                unit: 'hour',
                align: 'center',
                dateFormat: 'HH',
                increment: 6
            }
        ]
    },

    // >>> columns ----------------------------------------
    columns: [
        // >>> ---------------------------------- 'rownumber'
        {
            type: 'rownumber',
            hidden: false,
            region: 'right'
        },
        // >>> ---------------------------------- 'lastName' ('filterableName')
        {
            type: 'resourceInfo',
            text: 'Staff',
            field: 'lastName',
            width: 230,
            editor: false, // disables double click editor
            sortable: false,  // disables sort function (ticket #61)
            groupable: false,
            enableCellContextMenu: true, // enables right click context menu
            cellMenuItems: {
                customItem: {
                    text : '<span style="color: #424242;">SET - "EMPLOYEE(S) ON FLIGHT(S)"</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;<span style="float:right; color: #424242;">(multiple)</span>',
                    icon : 'b-fa b-fa-people-arrows',
                    cls  : 'b-separator',
                    style: 'color: #607d8b;',
                    onItem(resource) {
                        eventBus.$emit('setemployeesonflights', resource.record.data);
                    },
                },
            },
            renderer({ cellElement, record }) {
                return `
                    <div class="resourceColumn">
                        <div class="resourceColumn__bubbleTag">${record.data.firstNameFirstLetter + '' + record.lastNameFirstLetter}</div>
                        <div style="flex: 1;">
                            <p class="font-weight-medium">
                                ${record.data.lastName + ', ' + record.data.firstName}
                                ${record.data.experienced === true ? '' : '*' }
                            </p>
                            <p class="text--secondary caption">${record.data.contract3Code + ' - ' + record.data.contractFunction + '&nbsp;&nbsp;' + record.data.contractAddFunction}
                            </p>
                        </div>
                        <div>
                            <i style="float: right; font-size:11px; cursor: pointer; color: #92346a;" class="b-fa b-fa-phone" onClick="javascript:alert(\' ${record.data.comPhone1} \');"></i>
                        </div>
                    </div>`;
            },
            filterable : {
                filterFn ({ record, value }) {
                    let splittedValues = value.split(','), // #207
                        retValue = false;

                    for (let i = 0; i < splittedValues.length; i++) {
                        if (record.filterableName.toLowerCase().indexOf(splittedValues[i].toLowerCase().trim()) !== -1) {
                            retValue = true;
                        }
                    }


                    return retValue;
                    // return record.filterableName.toLowerCase().indexOf(value.toLowerCase()) !== -1; // older single valuer variant
                },
                filterField : {
                    placeholder : 'Filter by name(s)',
                    value: ''
                }
            },
            sum: 'count',
            summaryRenderer: ({ sum }) => sum + ' Employees'
        },
        // >>> ---------------------------------- 'baseStationCode'
        {
            field: 'baseStationCode',
            text: 'Base',
            width: 50,
            hidden: false,
            editor: false, // disables double click editor
            enableCellContextMenu: false, // disables right click context menu
            align: 'center',
            renderer({ cellElement, record }) {
                cellElement.style.fontSize = '11px';
                cellElement.style.fontWeight= '700';

                return record.data.baseStationCode !== null ? record.data.baseStationCode.trim() : 'XXX';
            }
        },
    ],

    // >>> stores -----------------------------------------
    events: [],
    resources: [],
    resourceTimeRanges: [],

    // >>> listeners --------------------------------------
    listeners: {
        // >>> Event Selection Change -----------
        eventSelectionChange: (event) => {

            eventBus.$emit('eventSelectionChange_Calendar', event);

        }, // eo function eventSelectionChange()

        // >>> Resource Selection Change --------
        selectionChange: (event) => {

            eventBus.$emit('selectionChange_Calendar', event);

        }, // eo function selectionChange()

        // >>> Before Event Edit  ---------------
        beforeEventEdit: (event) => {

            let allowedDutiesToEdit = [
                'DAYOFF', 'FREEDAY', 'VACATION', 'UNABLEFLIGHT', 'AVAILABLE',
                'SICKNESS', 'RESERVE', 'STANDBY', 'OFFICE',
                'HOTEL', 'PROCEEDING', 'TRAINING', 'MEETING', 'FLIGHT'
            ];


            // >>> ------------------------------------------------------------ // >>> guard, admin past
            if (!Vue.prototype.$isActionAllowed({ datesToCheck: [event.eventRecord.data.startDate], isAdmin: store.getters.get_shared_IsEditingInThePastAllowed })) { // #45
                Vue.prototype.$toasted.global.sdr_app_info({
                    message: 'Note: Dear User, no Changes in Past possible.'
                });
                return false;
            }

            // >>> ------------------------------------------------------------ // >>> guard
            if (!allowedDutiesToEdit.includes(event.eventRecord.name)) {
                return false;
            }



            // >>> ------------------------------------------------------------ // >>> Single Edit
            if (event.eventRecord.name === 'FLIGHT') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.flight' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit FLIGHT.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'FREEDAY') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.freeday' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit FREEDAY.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'VACATION') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.vacation' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit VACATION.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'AVAILABLE') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.available' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit AVAILABLE.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'RESERVE') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.reserve' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit RESERVE.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }
            // <<< ------------------------------------------------------------

            // >>> ------------------------------------------------------------ // >>> Multiple Edit
            if (event.eventRecord.name === 'HOTEL') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.hotel' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit HOTEL.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'PROCEEDING') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.proceeding' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit PROCEEDING.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'TRAINING') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.training' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit TRAINING.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'MEETING') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.meeting' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit MEETING.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'STANDBY') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.standby' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit STANDBY.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'SICKNESS') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.sickness' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit SICKNESS.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'UNABLEFLIGHT') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.unableflight' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit UNABLEFLIGHT.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'OFFICE') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.office' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit OFFICE.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }

            if (event.eventRecord.name === 'DAYOFF') {
                if (!store.getters.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.dayoff' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to edit DAYOFF.'
                    });
                    return false;
                } else {
                    eventBus.$emit('beforeEventEdit_Calendar', event);
                }
            }
            // <<< ------------------------------------------------------------

        }, // eo function beforeEventEdit()

        // >>> Before Event Drag  ---------------
        beforeEventDrag: ({ eventRecord }) => {

            // TODO: With Event Emit?
            // Drag FLight only from Calendar to Flights
            // return eventRecord.data.name === 'FLIGHT';
            return false;


        }, // eo function beforeEventDrag()

        // >>> Drag&Drop - 'Flights to Calendar'
        beforeEventDropFinalize: (event) => {

            const { context } = event;
            const { eventRecords } = context;


            eventBus.$emit('eventBeforeEventDropFinalize_FlightsToCalendar', event);

        }, // eo function beforeEventDropFinalize()

        // >>> just for Fun right now -----------
        datachange: (event) => {
            eventBus.$emit('datachange', event);
        } // eo function datachange()
    },
};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$                       /$$$$$$  /$$                  /$$$$$$
// #   /$$__  $$                     /$$__  $$|__/                 /$$__  $$
// #  | $$  \__/  /$$$$$$  /$$$$$$$ | $$  \__/ /$$  /$$$$$$       |__/  \ $$
// #  | $$       /$$__  $$| $$__  $$| $$$$    | $$ /$$__  $$        /$$$$$$/
// #  | $$      | $$  \ $$| $$  \ $$| $$_/    | $$| $$  \ $$       /$$____/
// #  | $$    $$| $$  | $$| $$  | $$| $$      | $$| $$  | $$      | $$
// #  |  $$$$$$/|  $$$$$$/| $$  | $$| $$      | $$|  $$$$$$$      | $$$$$$$$
// #   \______/  \______/ |__/  |__/|__/      |__/ \____  $$      |________/
// #                                               /$$  \ $$
// #                                              |  $$$$$$/
// #                                               \______/
// #    /$$$$$$            /$$                       /$$           /$$
// #   /$$__  $$          | $$                      | $$          | $$
// #  | $$  \__/  /$$$$$$$| $$$$$$$   /$$$$$$   /$$$$$$$ /$$   /$$| $$  /$$$$$$   /$$$$$$
// #  |  $$$$$$  /$$_____/| $$__  $$ /$$__  $$ /$$__  $$| $$  | $$| $$ /$$__  $$ /$$__  $$
// #   \____  $$| $$      | $$  \ $$| $$$$$$$$| $$  | $$| $$  | $$| $$| $$$$$$$$| $$  \__/
// #   /$$  \ $$| $$      | $$  | $$| $$_____/| $$  | $$| $$  | $$| $$| $$_____/| $$
// #  |  $$$$$$/|  $$$$$$$| $$  | $$|  $$$$$$$|  $$$$$$$|  $$$$$$/| $$|  $$$$$$$| $$
// #   \______/  \_______/|__/  |__/ \_______/ \_______/ \______/ |__/ \_______/|__/
// #
//-----------------------------------------------------------------------------/
const scheduler2Config = {                                                      // 'Flights'
    startDate: new Date(2021, 9, 21, 0),
    endDate: new Date(2021, 10, 21, 0),

    // >>> layout -----------------------------------------
    rowHeight: 86,
    barMargin: 4,
    resourceMargin: 6,
    flex: '1 30%', // 1 1 50%

    // >>> features ---------------------------------------
    stripeFeature: true,
    nonWorkingTimeFeature: true, // 'weekends'
    // useInitialAnimation: 'slide-from-left',
    createEventOnDblClick: false,
    filterBarFeature: true,
    columnLinesFeature: true,
    eventResizeFeature: false,
    cellTooltipFeature: false,
    scheduleTooltipFeature: false,
    resourceTimeRangesFeature: false, // BD

    // >>> copy&paste -------------------------------------
    eventCopyPasteFeature: false,
    rowCopyPasteFeature: false,

    // >>> drag&drop --------------------------------------
    multiEventSelect : true,
    eventDragSelectFeature: true,
    eventDragCreateFeature: false,
    eventDragFeature: {
        constrainDragToTimeline: false, // Allow drag outside of this Scheduler
        constrainDragToResource: false, // Resource fixed, only allowed to change start date
        constrainDragToTimeSlot: true, // Start date is fixed, only move between resources
        tooltipTemplate: (event) => { // { eventRecord, startDate }
            const { eventRecord, startDate } = event;


            return `
                <p style="font-size: 1.1rem">
                    Drag Flight(s):
                    ${event.dragData.draggedRecords.map((record) => `
                        <span style="font-weight: 700;">${record.data.legInfo.flightNo}</span>
                    `).join(', ')}
                    <br />
                    Onto Member: <span style="font-weight: 700;">${event.dragData.newResource && event.dragData.newResource.data.contract3Code !== undefined ? event.dragData.newResource.data.contract3Code : 'XXX' }</span>
                </p>
            `
        },
        validatorFn({ eventRecords, newResource }) {
            const task  = eventRecords[0],
                // valid = newResource.role === task.resource.role;
                valid = true;


            return {
                valid   : valid,
                message : valid ? '' : 'Resource role does not match required role for this task'
            };
        }
    },

    // >>> timeRangesFeature ------------------------------
    timeRangesFeature: {
        showCurrentTimeLine: true,
        showHeaderElements: true,
        enableResizing: false,
    },

    // >>> timeAxisHeaderMenuFeature ----------------------
    timeAxisHeaderMenuFeature: {
        items : {
            zoomLevel : false,
            eventsFilter: false,
            dateRange: false,
            currentTimeLine: false,
        }
    },

    // >>> summaryFeature ---------------------------------
    summaryFeature: {
        renderer : ({ events }) => events.length || ''
    },

    // >>> eventMenuFeature -------------------------------
    eventMenuFeature: {
        items: {
            deleteEvent : false,
            cutEvent: false,
            copyEvent: false,
            editEvent : true,
        },
        processItems({ eventRecord, items }) {
            items.deleteEvent = false;
            // items.editEvent.text = 'SEE FLIGHT DETAILS ----- (single)'; // off right now
            items.editEvent = false;

            items.edit_CREWONFLIGHT = {
                html : '<span style="color: #424242;">EDIT - "CREW ON FLIGHT" </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;<span style="float:right; color: #424242;">(multiple)</span>',
                icon : 'b-fa b-fa-user-friends',
                cls  : 'b-separator ',
                style: 'color: #607d8b;',
                onItem (ev) { // { date, resourceRecord }
                    const { eventRecord } = ev;


                    eventBus.$emit('onclickupdatecrewonflight', ev);
                    this.hide();
                }
            };

            items.see_FLIGHTDETAILS = {
                html : '<span style="color: #424242;">SHOW - "CREW DETAILS"</span><span style="float:right; color: #424242;">(multiple)</span>',
                icon : 'b-fa b-fa-people-arrows',
                cls  : 'b-separator ',
                style: 'color: #607d8b;',
                onItem (ev) { // { date, resourceRecord }
                    const { eventRecord } = ev;


                    eventBus.$emit('onclickseecrewdetails', { eventRecord });
                    this.hide();
                }
            };

            items.see_CREWONFLIGHT = {
                html : '<span style="color: red;">FILTER - "CREW IN CALENDAR"</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;&nbsp&nbsp;&nbsp;<span style="float:right; color: red;">(filtered)</span>',
                icon : 'b-fa b-fa-filter',
                cls  : 'b-separator ',
                style: 'color: red; padding-top: 20px; padding-bottom: 20px;',
                onItem (ev) { // { date, resourceRecord }
                    const { eventRecord } = ev;


                    eventBus.$emit('onclickfilterforcrewoncalendar', ev);
                    this.hide();
                }
            };

            // Prevent menu for "locked" event
            return !eventRecord.locked;
        },
    },

    // >>> scheduleMenuFeature ----------------------------
    scheduleMenuFeature: {
        processItems({date, resourceRecord, items}) {
            items.addEvent =  false;
        }
    },

    // >>> eventEditFeature -------------------------------
    eventEditFeature: {
        triggerEvent: {
            eventdblclick: null
        }
    },

    // >>> eventTooltipFeature ----------------------------
    eventTooltipFeature: {
        hideOnDelegateChange: true,
        tools : [
            // >>> ------------------------------ Complete Names
            {
                cls     : 'b-fa b-fa-users',
                style: 'color: #fff;',
                tooltip : '<span style="font-family: Roboto;">Show complete Names</span>',
                handler : function() {
                    eventBus.$emit('onclickshowcompletenames', this.eventRecord.data.legInfo.crewCodes);
                    this.hide();
                }
            },
        ],
        bodyCls : {
            'b-my-class': 1,
        },
        template: data => {
            return `
                <div style="display: grid; grid-template-columns: auto auto auto; column-gap: 12px;">

                    <p style="font-weight: 600;font-size: 1.1rem;">${data.eventRecord.legInfo.flightNo}</p>
                    <p>${data.eventRecord.legInfo.aptFrom.aptCode}</p>
                    <p>${data.eventRecord.legInfo.aptTo.aptCode}</p>
                    <p style="">Scheduled:</p>
                    <p>${dayjs(data.eventRecord.legInfo.dep_sch_time).utc().format('HH:mm')} <sup>UTC</sup></p>
                    <p style="">${dayjs(data.eventRecord.legInfo.arr_sch_time).utc().format('HH:mm')} <sup>UTC</sup></p>
                    <p style=""></p>
                    <p>${Vue.prototype.$dayjsUTCToLocal(data.eventRecord.legInfo.dep_sch_time, 'HH:mm')} <sup>${data.eventRecord.legInfo.aptFrom.aptCode}</sup></p>
                    <p style="">${Vue.prototype.$dayjsUTCToLocal(data.eventRecord.legInfo.arr_sch_time, 'HH:mm')} <sup>${data.eventRecord.legInfo.aptTo.aptCode}</sup></p>

                    <hr style="grid-column-start:1;grid-column-end:4;margin:10px 0;" />



                    <p style="font-weight: 600;font-size: 1.1rem;">${data.eventRecord.legInfo.flightNo}</p>
                    <p>${data.eventRecord.legInfo.aptFrom.aptCode}</p>
                    <p>${data.eventRecord.legInfo.aptTo.aptCode}</p>
                    <p style="">Actual:</p>
                    <p>${dayjs(data.eventRecord.legInfo.departureTime).utc().format('HH:mm')} <sup>UTC</sup></p>
                    <p style="">${dayjs(data.eventRecord.legInfo.arrivalTime).utc().format('HH:mm')} <sup>UTC</sup></p>
                    <p style=""></p>
                    <p>${Vue.prototype.$dayjsUTCToLocal(data.eventRecord.legInfo.departureTime, 'HH:mm')} <sup>${data.eventRecord.legInfo.aptFrom.aptCode}</sup></p>
                    <p style="">${Vue.prototype.$dayjsUTCToLocal(data.eventRecord.legInfo.arrivalTime, 'HH:mm')} <sup>${data.eventRecord.legInfo.aptTo.aptCode}</sup></p>

                    <hr style="grid-column-start:1;grid-column-end:4;margin:10px 0;" />



                    <p>CrewCodes:</p>
                    ${data.eventRecord.legInfo.crewCodes !== null ?
                        `<p style="grid-column-start:2;grid-column-end:4">${data.eventRecord.legInfo.crewCodes}</p>`
                    : `<p style="grid-column-start:2;grid-column-end:4">-</p>` }


                    <p>Errors:</p>
                    ${data.eventRecord.legInfo.errors !== null ?
                        `<p style="grid-column-start:2;grid-column-end:4">${data.eventRecord.legInfo.errors}</p>`
                    : `<p style="grid-column-start:2;grid-column-end:4">-</p>` }


                    <p style="padding-top: 10px;">Type(s):</p>
                    ${data.eventRecord.legInfo.crewConstellationCheck && data.eventRecord.legInfo.crewConstellationCheck.validCockpit === false ?
                        `<p style="grid-column-start:2;grid-column-end:4; padding-top: 10px;">ERROR(s) in COCKPIT.</p>`
                    : `<p style="grid-column-start:2;grid-column-end:4; padding-top: 10px">-</p>` }
                    ${data.eventRecord.legInfo.crewConstellationCheck && data.eventRecord.legInfo.crewConstellationCheck.validCabin === false ?
                        `<p style="grid-column-start:2;grid-column-end:4; padding-top: 10px;">ERROR(s) in CABIN.</p>`
                    : `<p style="grid-column-start:2;grid-column-end:4; padding-top: 10px">-</p>` }


                    <p style="padding-top: 10px;">Restriction(s):</p>
                    ${data.eventRecord.legInfo.validateExtends.validated === false ?
                        `<p style="grid-column-start:2;grid-column-end:4; padding-top: 10px">EASA Restriction</p>`
                    : `<p style="grid-column-start:2;grid-column-end:4; padding-top: 10px">-</p>` }

                    ${data.eventRecord.legInfo.validateExtends.errors.map(function (key) {
                        return `<p style="grid-column-start:1;grid-column-end:4; padding-top: 10px; font-weight: 600;">
                            [ ${key.resourceCode} ]: ${key.restrictions[0]} ${key.ilegalPeriod && key.ilegalPeriod.fromDate ? ' => ' + dayjs(key.ilegalPeriod.fromDate).utc().format('DD.MM.YYYY') + '-' + dayjs(key.ilegalPeriod.toDate).utc().format('DD.MM.YYYY') : ''}
                        </p>`
                    }).join(``)}

                </div>`;
        },
    },

    // >>> eventRenderer ----------------------------------
    eventRenderer({ eventRecord, resourceRecord, renderData }) {

        let eventRecord_isEmpty = Vue.prototype.$isEmpty(eventRecord.legInfo),
            firstLine,
            secondLine_AU,
            secondLine_AL,
            thirdLine_SU,
            thirdLine_SU_Dep,
            thirdLine_SU_Arr,
            thirdLine_SL,
            fourthLine = '',
            fourthLine_SU_Dep,
            fourthLine_SU_Arr,
            iconCls;


        // >>> --------------------------------------------
        if (!eventRecord_isEmpty) {
            let arr_slt_time_isEmpty = Vue.prototype.$isEmpty(eventRecord.legInfo.arr_slt_time);
            let dep_slt_time_isEmpty = Vue.prototype.$isEmpty(eventRecord.legInfo.dep_slt_time);

            // FirstLine    - Flight Number and Flight Type
            firstLine = eventRecord.name

            // SecondLine   - Actual Flight Time (UTC / Local)
            secondLine_AU =
                dayjs(eventRecord.legInfo.departureTime)
                    .utc()
                    .format('HH:mm') +
                '-' +
                dayjs(eventRecord.legInfo.arrivalTime)
                    .utc()
                    .format('HH:mm');
            secondLine_AL = Vue.prototype.$dayjsUTCToLocal(eventRecord.legInfo.departureTime, 'HH:mm') + '-' + Vue.prototype.$dayjsUTCToLocal(eventRecord.legInfo.arrivalTime, 'HH:mm');

            // ThirdLine    - Scheduled Flight Time (UTC / Local)
            thirdLine_SU =
                dayjs(eventRecord.legInfo.dep_sch_time)
                    .utc()
                    .format('HH:mm') +
                '-' +
                dayjs(eventRecord.legInfo.arr_sch_time)
                    .utc()
                    .format('HH:mm');
            thirdLine_SL = Vue.prototype.$dayjsUTCToLocal(eventRecord.legInfo.dep_sch_time, 'HH:mm') + '-' + Vue.prototype.$dayjsUTCToLocal(eventRecord.legInfo.arr_sch_time, 'HH:mm');

            thirdLine_SU_Dep = dayjs(eventRecord.legInfo.dep_sch_time).utc().format('HH:mm');
            thirdLine_SU_Arr = dayjs(eventRecord.legInfo.arr_sch_time).utc().format('HH:mm');


            // FourthLine   - Slot Time (UTC)
            if (!arr_slt_time_isEmpty || !dep_slt_time_isEmpty) {
                // Departure Airport Code + Time
                fourthLine += eventRecord.legInfo.aptFrom.aptCode;
                if (!dep_slt_time_isEmpty) {
                    fourthLine +=
                        '-' +
                        dayjs(eventRecord.legInfo.dep_slt_time)
                            .utc()
                            .format('HH:mm');
                }
                // Arrival Airport Code + Time
                fourthLine += ', ';
                fourthLine += eventRecord.legInfo.aptTo.aptCode;
                if (!arr_slt_time_isEmpty) {
                    fourthLine +=
                        '-' +
                        dayjs(eventRecord.legInfo.arr_slt_time)
                            .utc()
                            .format('HH:mm');
                }
            };
            // FourthLine   - Slot Time (UTC)
            if (!arr_slt_time_isEmpty || !dep_slt_time_isEmpty) {
                // Departure Airport Code + Time

                if (!dep_slt_time_isEmpty) {
                    fourthLine_SU_Dep = dayjs(eventRecord.legInfo.dep_slt_time).utc().format('HH:mm');
                }
                // Arrival Airport Code + Time

                if (!arr_slt_time_isEmpty) {
                    fourthLine_SU_Arr = dayjs(eventRecord.legInfo.arr_slt_time).utc().format('HH:mm');
                }
            }
        }


        // >>> --------------------------------------------
        return {
            leg: !eventRecord_isEmpty ? eventRecord.legInfo.leg : '',
            leg_dep: !eventRecord_isEmpty ? eventRecord.legInfo.aptFrom.aptCode : '',
            leg_arr: !eventRecord_isEmpty ? eventRecord.legInfo.aptTo.aptCode : '',
            legInfo: !eventRecord_isEmpty ? eventRecord.legInfo : '',
            firstLine: firstLine,
            secondLine_AU: secondLine_AU,
            secondLine_AL: secondLine_AL,
            thirdLine_SU: thirdLine_SU,
            thirdLine_SU_Dep: thirdLine_SU_Dep,
            thirdLine_SU_Arr: thirdLine_SU_Arr,
            thirdLine_SL: thirdLine_SL,
            fourthLine: fourthLine,
            fourthLine_SU_Dep: fourthLine_SU_Dep,
            fourthLine_SU_Arr: fourthLine_SU_Arr,
            flightType: !eventRecord_isEmpty ? eventRecord.legInfo.flightType : '',

            iconCls: eventRecord.iconCls,
            iconSlot: 'v-icon mdi mdi-subdirectory-arrow-right',
            crewCodes: !eventRecord_isEmpty ? eventRecord.legInfo.crewCodes : '',
        };

    },

    eventBodyTemplate: data => `
        <div class="sdr-sch-event-container style="position: relative;">
            <section style="height: 100%; display: grid; grid-template-columns: 15px 1fr 1fr;grid-template-rows: 1fr auto 1fr; column-gap: 8px;">
                <div style="grid-row-start: 1;grid-row-end: 4; align-self: center; width: 80px; height: 85px; transform: rotate(-90deg);">
                    <p style="font-weight: 600;font-size: 1.0rem; text-align: center;">
                        ${data.leg_dep}-${data.leg_arr}
                    </p>
                </div>

                <p style="font-size: 1.0rem; align-self: flex-end; font-weight: 600; margin-left: 12px !important;"><span>${data.leg_dep}</span></p>
                <p style="font-size: 1.0rem; align-self: flex-end; font-weight: 600;"><span>${data.leg_arr}</span></p>
                <p style="font-size: 1.2rem; margin-left: 12px !important;">${data.thirdLine_SU_Dep} <sup style="font-size: 8.4px;">UTC</sup></p>
                <p style="font-size: 1.2rem;">${data.thirdLine_SU_Arr} <sup style="font-size: 8.4px;">UTC</sup></p>
                <p style="font-size: 0.80rem; margin-left: 12px !important; grid-column-end: 4; grid-column-start: 2;">${data.crewCodes}</p>
            </section>
            <i class="sdr-sch-event-icon ${data.iconCls || ''}"></i>

            ${ data.legInfo.crewConstellationCheck && data.legInfo.crewConstellationCheck.validCockpit === false ? '<div style="position: absolute; right: 0; top: 0; width: 20px; height: 20px; background: purple; clip-path: polygon(0 0, 100% 0, 100% 100%)"></div>' : '' }
            ${ data.legInfo.crewConstellationCheck && data.legInfo.crewConstellationCheck.validCabin === false ?  '<div style="position: absolute; right: 0; bottom: 0; width: 20px; height: 20px; background: purple; clip-path: polygon(100% 0, 100% 100%, 0 100%)"></div>' : '' }
        </div>
    `,

    // >>> presets ----------------------------------------
    presets: [
        { // >>> 'normalPreset'
            id: 'normalPresetFlights',
            name: 'Sundair Custom Day Preset',
            tickWidth: 75,
            timeResolution: {
                unit: 'minute',
                increment: 5
            },
            headers: [
                {
                    unit: 'day',
                    align: 'center',
                    dateFormat: 'ddd, Y-MM-DD'
                },
                {
                    unit: 'hour',
                    align: 'center',
                    dateFormat: 'HH',
                    increment: 2

                }
            ],
        },
    ],

    // >>> viewPreset -------------------------------------
    viewPreset: {
        base: 'hourAndDay',
        tickWidth: 75,
        headers: [
            {
                unit: 'day',
                align: 'center',
                dateFormat: 'ddd, Y-MM-DD'
            },
            {
                unit: 'hour',
                align: 'center',
                dateFormat: 'HH',
                increment: 6
            }
        ]
    },

    // >>> columns ----------------------------------------
    columns: [
        // >>> ---------------------------------- 'rownumber'
        {
            type: 'rownumber',
            hidden: false,
            region: 'right'
        },
        // >>> ---------------------------------- 'resourceInfo' ('filterable')
        {
            type: 'resourceInfo',
            text: 'Aircraft',
            field: 'name',
            width: 290,
            editor: false, // disables double click editor
            sortable: false,  // disables sort function (ticket #61)
            renderer: ({ record }) => {
                return `
                    <div class="resourceColumn">
                    <div class="resourceColumn__bubbleTag" style="width: 55px; border-radius: 12%">${record.bubblename}</div>
                    <div style="flex: 1;">
                        <p class="font-weight-medium">${record.name}</p>
                        <p class="text--secondary caption font-weight-medium">Capacity: ${record.capacityY + 'Y/' + record.capacityC + 'C'}</p>
                    </div>
                    <div>
                        <i style="float: right; font-size:11px; cursor: pointer; color: #92346a;" class="b-fa b-fa-plane-departure"></i>
                    </div>
                </div>`;
            },
            filterable : {
                filterFn ({ record, value }) {
                    let splittedValues = value.split(','), // #207
                        retValue = false;


                    for (let i = 0; i < splittedValues.length; i++) {
                        if (record.name.toLowerCase().indexOf(splittedValues[i].toLowerCase().trim()) !== -1) {
                            retValue = true;
                        }
                    }


                    return retValue;
                    // return record.filterableName.toLowerCase().indexOf(value.toLowerCase()) !== -1; // older single valuer variant
                },
                filterField : {
                    placeholder : 'Filter by aircraft(s)',
                    value: ''
                }
            },
            // filterable : {
            //     filterField : {
            //         placeholder : 'Filter by aircraft'
            //     }
            // },
            sum: 'count',
            summaryRenderer: ({ sum }) => sum + ' Aircrafts'
        },
    ],

    // >>> Stores -----------------------------------------
    events: [],
    resources: [],
    resourceTimeRanges: [],

    // >>> listeners --------------------------------------
    listeners: {
        // >>> Event Selection Change -----------
        eventSelectionChange: (event) => {

            eventBus.$emit('eventSelectionChange_Flights', event);

        }, // eo function eventSelectionChange()

        // >>> Resource Selection Change --------
        selectionChange: (event) => {

            eventBus.$emit('selectionChange_Flights', event);

        }, // eo function selectionChange()

        // >>> Before Event Edit  ---------------
        beforeEventEdit: (event) => {
            eventBus.$emit('beforeEventEdit_Flights', event);
        }, // eo function beforeEventEdit()

        // >>> D&D - 'Flights in Flights' -------
        beforeEventDropFinalize: (event) =>  {

            const { context } = event;
            const { eventRecords } = context;


            // >>> --------------------
            Vue.prototype.$toasted.global.sdr_app_error({
                message: 'Pardon this is not possible. Drag Flights in Flights.'
            });

            // >>> --------------------
            if (context.draggedRecords.length === 1) {
                context.async = true;
                setTimeout(() => {
                    // async code don't forget to call finalize
                    context.finalize();
                }, 400);
            }

            // >>> --------------------
            if (context.draggedRecords.length > 1) {
                eventBus.$emit('createnewflightinflights', context.draggedRecords.map((record) => record.data.legInfo)); // Emit 3: create/reset new Flight (in 'Flights')
            }

            // >>> --------------------
            setTimeout(() => {
                eventBus.$emit('deselectallflights');
            }, 700);

        }, // eo function beforeEventDropFinalize()
    }
};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export { scheduler1Config, scheduler2Config };
